export class ArgumentNullException extends Error {
    constructor() {
        super(...arguments);
        this.name = "ArgumentNullException";
    }
}
export class BadArgumentException extends Error {
    constructor() {
        super(...arguments);
        this.name = "BadArgumentException";
    }
}
export class NotImplementedException extends Error {
    constructor() {
        super(...arguments);
        this.name = "NotImplementedException";
    }
}
export class InvalidConfigurationError extends Error {
    constructor() {
        super(...arguments);
        this.name = "InvalidConfigurationError";
    }
}
export class InvalidOperationException extends Error {
    constructor() {
        super(...arguments);
        this.name = "InvalidOperationException";
    }
}
export class UnauthorizedError extends Error {
    constructor() {
        super(...arguments);
        this.name = "UnauthorizedError";
        this.skipReporting = true;
        this.errorType = "UNAUTHORIZED";
        this.extensions = {
            name: this.name,
            errorType: this.errorType,
            skipReporting: this.skipReporting,
        };
    }
}
export class UnauthenticatedError extends Error {
    constructor() {
        super(...arguments);
        this.name = "UnauthenticatedError";
        this.skipReporting = true;
        this.errorType = "UNAUTHENTICATED";
        this.extensions = {
            name: this.name,
            errorType: this.errorType,
            skipReporting: this.skipReporting,
        };
    }
}
export class PermissionsNotFoundError extends Error {
    constructor() {
        super(...arguments);
        this.name = "PermissionsNotFoundError";
        // Likely a misconfiguration or something that user should take action to fix
        this.skipReporting = false;
    }
}
export class EntityNotFoundError extends Error {
    constructor(entityType, id) {
        super(`Could not find ${entityType} with id = ${id}`);
        this.name = "EntityNotFoundError";
        this.skipReporting = true;
        this.errorType = "NOT_FOUND";
        this.extensions = {
            name: this.name,
            errorType: this.errorType,
            skipReporting: this.skipReporting,
        };
    }
}
export class AiSummaryGenerationError extends Error {
    constructor() {
        super(...arguments);
        this.name = "AiSummaryGenerationError";
    }
}
export class AiSummaryNotSummarizableError extends Error {
    constructor() {
        super(...arguments);
        this.name = "AiSummaryNotSummarizableError";
        this.skipReporting = true;
    }
}
export class DocumentNotSignableError extends Error {
    constructor() {
        super(...arguments);
        this.name = "DocumentNotSignableError";
        this.skipReporting = true;
        this.errorType = "DOCUMENT_NOT_SIGNABLE";
        this.extensions = {
            name: this.name,
            errorType: this.errorType,
            skipReporting: this.skipReporting,
        };
    }
}
//# sourceMappingURL=error.js.map